import { JSX, SVGProps } from 'react';

export const Strapi = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={57}
    height={57}
    viewBox="0 0 57 56"
    {...props}
  >
    <defs>
      <clipPath id="b">
        <path d="M0 0h57v57H0z" />
      </clipPath>
      <clipPath id="c">
        <path d="M0 0h57v57H0z" />
      </clipPath>
      <mask id="e">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.403922,
              stroke: 'none',
            }}
            d="M0 0h57v56H0z"
          />
        </g>
      </mask>
      <mask id="g">
        <g filter="url(#a)">
          <path
            style={{
              fill: '#000',
              fillOpacity: 0.403922,
              stroke: 'none',
            }}
            d="M0 0h57v56H0z"
          />
        </g>
      </mask>
      <g id="d" clipPath="url(#b)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: '#8e75ff',
            fillOpacity: 1,
          }}
          d="M18.168.438V18.89H.594a.6.6 0 0 1-.551-.364.58.58 0 0 1 .133-.636Zm20.64 54.953a.6.6 0 0 1-.648.125.59.59 0 0 1-.367-.54V37.923h19.031Zm0 0"
        />
      </g>
      <g id="f" clipPath="url(#c)">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: '#8e75ff',
            fillOpacity: 1,
          }}
          d="M18.168 18.89h19.031a.59.59 0 0 1 .594.587v18.445H19.359a1.18 1.18 0 0 1-1.187-1.172V18.89Zm0 0"
        />
      </g>
      <filter id="a" filterUnits="objectBoundingBox" x="0%" y="0%" width="100%" height="100%">
        <feColorMatrix in="SourceGraphic" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
      </filter>
    </defs>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#8e75ff',
        fillOpacity: 1,
      }}
      d="M55.633.438H18.172V18.89h18.433c.657 0 1.188.523 1.188 1.168v17.863h19.031V1.609c0-.312-.125-.609-.347-.828a1.2 1.2 0 0 0-.844-.343m0 0"
    />
    <use xlinkHref="#d" mask="url(#e)" />
    <use xlinkHref="#f" mask="url(#g)" />
  </svg>
);
